import { useState } from 'react';
import getNextConfig from 'next/config';
import type { NextRuntimeConfiguration } from '@hub/libs/config';
import type { WidenApiAssetByIdBaseResponse } from '@hub/libs/widen-api';

const { publicRuntimeConfig } = getNextConfig() as NextRuntimeConfiguration;

export const useWidenAsset = () => {
  const [widenAsset, setWidenResponse] = useState<WidenApiAssetByIdBaseResponse>();

  const getAssetByExternalId = async (externalId: string, fileType = 'pdf') => {
    const url = `${publicRuntimeConfig.koplaServices}/dam/cdn/content/${externalId}/${fileType}`;
    const response = await fetch(url, {
      method: 'HEAD',
    });
    if (!response.ok) {
      if (response.status === 404) {
        throw new Error(`Resource ${externalId} not found`);
      } else {
        throw new Error(`${response.status}`);
      }
    }
    return url;
  };

  const getWidenAsset = async (widenId: string, expand = ['embeds']) => {
    const url = `${publicRuntimeConfig.koplaServices}/dam/api2/assets/${widenId}?expand=${expand.join(',')}`;
    const response = await fetch(url);

    if (response.ok) {
      const widenResponseData = (await response.json()) as WidenApiAssetByIdBaseResponse;
      setWidenResponse(widenResponseData);
    }
  };

  return { getWidenAsset, widenAsset, getAssetByExternalId };
};
